import React, { useState, useEffect } from 'react';

var IconClose = function IconClose() {
  return React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 17.4 17.3",
    xmlSpace: "preserve"
  }, React.createElement("path", {
    d: "M0.7,16c0-0.2,0.1-0.4,0.2-0.5L15.5,0.9c0.3-0.3,0.7-0.3,1,0s0.3,0.7,0,1L1.9,16.5c-0.3,0.3-0.7,0.3-1,0C0.8,16.4,0.7,16.2,0.7,16z"
  }), React.createElement("path", {
    d: "M7.6,6.6L1.9,0.9c-0.3-0.3-0.7-0.3-1,0C0.8,1,0.7,1.2,0.7,1.4s0.1,0.4,0.2,0.5l5.7,5.7L7.6,6.6z"
  }), React.createElement("path", {
    d: "M9.8,10.8l5.7,5.7c0.3,0.3,0.7,0.3,1,0s0.3-0.7,0-1l-5.7-5.7L9.8,10.8z"
  }));
};

var IconShare = function IconShare() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "19",
    viewBox: "0 0 18 19"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    fill: "none",
    stroke: "#242020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "50",
    strokeWidth: "2",
    d: "M6.333 9.054a2.675 2.675 0 0 1-2.666 2.684A2.675 2.675 0 0 1 1 9.054 2.675 2.675 0 0 1 3.667 6.37a2.675 2.675 0 0 1 2.666 2.684z"
  })), React.createElement("g", null, React.createElement("path", {
    fill: "none",
    stroke: "#242020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "50",
    strokeWidth: "2",
    d: "M17.003 15.314a2.675 2.675 0 0 1-2.666 2.684 2.675 2.675 0 0 1-2.667-2.684 2.675 2.675 0 0 1 2.667-2.684 2.675 2.675 0 0 1 2.666 2.684z"
  })), React.createElement("g", null, React.createElement("path", {
    fill: "none",
    stroke: "#242020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "50",
    strokeWidth: "2",
    d: "M17.003 3.684a2.675 2.675 0 0 1-2.666 2.684 2.675 2.675 0 0 1-2.667-2.684A2.675 2.675 0 0 1 14.337 1a2.675 2.675 0 0 1 2.666 2.684z"
  })), React.createElement("g", null, React.createElement("path", {
    fill: "none",
    stroke: "#242020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "50",
    strokeWidth: "2",
    d: "M8.47 11.875l1.067.625"
  })), React.createElement("g", null, React.createElement("path", {
    fill: "none",
    stroke: "#242020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "50",
    strokeWidth: "2",
    d: "M8.47 6.636l1.067-.537"
  })))));
};

var ShareProduct = function ShareProduct(_ref) {
  var share = _ref.share,
      ShareIcon = _ref.ShareIcon,
      CloseIcon = _ref.CloseIcon,
      shareLinks = _ref.shareLinks,
      productURL = _ref.productURL,
      shareProductText = _ref.shareProductText,
      productLinkText = _ref.productLinkText,
      shareWebSocials = _ref.shareWebSocials,
      additionalOverlay = _ref.additionalOverlay;

  var _useState = useState(false),
      isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _useState2 = useState(false),
      isButtonClicked = _useState2[0],
      setIsButtonClicked = _useState2[1];

  var handleCloseModal = function handleCloseModal() {
    setIsModalOpen(!isModalOpen);
  };

  var handleCopyLink = function handleCopyLink() {
    var _navigator, _navigator$clipboard;

    (_navigator = navigator) == null ? void 0 : (_navigator$clipboard = _navigator.clipboard) == null ? void 0 : _navigator$clipboard.writeText(productURL);
    setIsButtonClicked(!isButtonClicked);
  };

  useEffect(function () {
    if (isButtonClicked) {
      var timer = setTimeout(function () {
        setIsButtonClicked(!isButtonClicked);
      }, 3000);
      return function () {
        return clearTimeout(timer);
      };
    }

    return undefined;
  }, [isButtonClicked]);
  return React.createElement("div", {
    "data-open-modal-container": true,
    "data-testid": "share-product-container"
  }, React.createElement("button", {
    onClick: handleCloseModal,
    "data-open-modal-button": true,
    "data-testid": "open-modal"
  }, React.createElement("i", {
    "data-open-modal-icon": true
  }, ShareIcon ? React.createElement(ShareIcon, null) : React.createElement(IconShare, null)), React.createElement("span", {
    "data-open-modal-text": true
  }, share ? share : 'Compartilhar')), isModalOpen && React.createElement(React.Fragment, null, additionalOverlay && React.createElement("div", {
    "data-additional-overlay": true,
    "data-testid": "additional-overlay",
    onClick: handleCloseModal
  }), React.createElement("div", {
    "data-modal-background": true
  }, React.createElement("div", {
    "data-modal-container": true
  }, React.createElement("button", {
    "data-close-modal-button": true,
    onClick: handleCloseModal,
    "data-testid": "close-modal"
  }, React.createElement("i", {
    "data-close-modal-icon": true
  }, CloseIcon ? React.createElement(CloseIcon, null) : React.createElement(IconClose, null))), React.createElement("p", {
    "data-modal-share-product-text": true
  }, shareProductText ? shareProductText : 'Compartilhar este produto'), React.createElement("div", {
    "data-modal-product-link-container": true
  }, React.createElement("span", {
    "data-modal-product-text": true
  }, productLinkText ? productLinkText : 'Link'), React.createElement("input", {
    "data-modal-product-link-input": true,
    type: "text",
    value: productURL,
    readOnly: true,
    "data-testid": "input"
  })), React.createElement("button", {
    onClick: handleCopyLink,
    "data-modal-copy-link-button": true,
    "data-testid": "copy-text"
  }, !isButtonClicked ? 'Copiar link' : 'Copiado'), React.createElement("div", {
    "data-modal-share-links-container": true
  }, shareWebSocials, React.createElement("div", {
    "data-modal-links-social": true
  }, shareLinks.map(function (_ref2, index) {
    var target = _ref2.target,
        name = _ref2.name,
        url = _ref2.url,
        SocialIcon = _ref2.SocialIcon;
    return React.createElement("a", {
      id: name,
      href: url,
      target: target ? target : '_blank',
      key: index,
      "data-modal-share-link": true,
      "data-testid": "link"
    }, React.createElement("i", {
      "data-modal-share-link-icon": true,
      "data-testid": "svg"
    }, React.createElement(SocialIcon, null), ' '));
  })))))));
};

export default ShareProduct;
//# sourceMappingURL=shareproduct.esm.js.map
